import { h, cloneElement, Component } from 'preact'
import { isValidElement } from 'preact-compat'

export default class Weekdays extends Component {
    shouldComponentUpdate(nextProps) {
        return this.props !== nextProps
    }

    render() {
        const {
            classNames,
            firstDayOfWeek,
            showWeekNumbers,
            weekdaysLong,
            weekdaysShort,
            locale,
            localeUtils,
            weekdayElement
        } = this.props
        const days = []
        for (let i = 0; i < 7; i += 1) {
            const weekday = (i + firstDayOfWeek) % 7
            const elementProps = {
                key: i,
                className: classNames.weekday,
                weekday,
                weekdaysLong,
                weekdaysShort,
                localeUtils,
                locale
            }
            const element = isValidElement(weekdayElement)
                ? cloneElement(weekdayElement, elementProps)
                : h(weekdayElement, elementProps)
            days.push(element)
        }

        return (
            <div className={classNames.weekdays} role="rowgroup">
                <div className={classNames.weekdaysRow} role="row">
                    {showWeekNumbers && <div className={classNames.weekday} />}
                    {days}
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./components/Datepicker/Weekdays.js